import React, { useEffect, useState } from 'react';
import '../styles/Footer.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

const Footer = () => {
  const [showTopButton, setShowTopButton] = useState(false);
  const navigate=useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setShowTopButton(window.scrollY > 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      <footer className="footer">
        <div className="footer-columns">
         <div className="footer-col logo-tagline" onClick={() => navigate('/')}>
        <img
          src="/taxtime.jpeg"   // put your logo file in public folder
          alt="tax timez"
          className="footer-logo"
        />
        <p>Empowering digital experiences.</p>
      </div>    


          <div className="footer-col">
            <h4>Pages</h4>
            <ul>
              <li onClick={()=>{navigate('/')}}>Home</li>
              <li onClick={()=>{navigate('/about')}}>About</li>
              <li onClick={()=>{navigate('/services')}}>Services</li>
              <li onClick={()=>{navigate('/contact')}}>Contact</li>
              <li onClick={()=>{navigate('/blogs')}}>Blogs</li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Address</h4>
             <p>B O - Sadasivpet & Vikarabad</p>

            <p>H.O - 12-12, MIG -58, Above SBI Bank, Opposite to Collectorate Sangareddy, Telangana - 502001</p>
          </div>

         <div className="footer-col">
  <h4>Follow Us</h4>
  <div className="social-icons">
    {/* <a href="https://www.facebook.com/yourpage" target="_blank" rel="noopener noreferrer">
      <FaFacebookF />
    </a> */}

    {/* <a href="https://twitter.com/yourprofile" target="_blank" rel="noopener noreferrer">
      <FaTwitter />
    </a> */}

    <a href="https://www.instagram.com/invites/contact/?igsh=16nm9k9b616eq&utm_content=xhrax3j" target="_blank" rel="noopener noreferrer">
      <FaInstagram />
    </a>

    {/* <a href="https://www.linkedin.com/in/yourprofile" target="_blank" rel="noopener noreferrer">
      <FaLinkedinIn />
    </a> */}

    <a href="https://youtube.com/@taxtimez?si=3_Sl8E8APXF2_b4H" target="_blank" rel="noopener noreferrer">
      <FaYoutube />
    </a>
  </div>
</div>
        </div>

        <div className="footer-line">
          <a href="#" >Terms & Conditions</a> | <a href="#">Privacy Policy</a>
        </div>

        <div className="footer-bottom">
          © 2025 All Rights Reserved.
        </div>
      </footer>

      <a href="https://wa.me/1234567890" className="whatsapp-icon" target="_blank" rel="noreferrer">
       <img src="images/home/banner/whatsapp.png" alt="icon not found" />
      </a>

      {showTopButton && (
        <button className="scroll-top-button" onClick={scrollToTop}>
          ⬆
        </button>
      )}
    </>
  );
};

export default Footer;
